
export class LineDayHourAbstractInfoModel {
    hour: number;
    plannedQuantity: number; // get this from the plan table
    outputQuantity: number; // get this from line_eff_day_track
    reworkQuantity: number; // get this from line_day_actual_track
    noOfOperators: number; // get this from line_day_actual_track
    productiveMinutes: number; // SUM(garments compeleted per op * SMV of that OP)
    efficiency: number; // ( [good quantity * op smv]/sum[hangerout - hangerin] ) // get sum(efficiency/no of observations) from line_eff_day_track
    idleMinutes: number; // NOT COVERED -- not done as of now
    idleWorkstations: number; // if good qty is 0 for any workstation + line then the workstation is idle // get it from line_day_actual_track
    totalStyles: number; // total styles in the line
    totalWorkstations: number; // total workstations in the line

    constructor(hour: number, plannedQuantity: number, outputQuantity: number, reworkQuantity: number,
        noOfOperators: number, productiveMinutes: number, efficiency: number,
        idleMinutes: number, idleWorkstations: number, totalStyles: number, totalWorkstations: number
    ) {
        this.hour = hour;
        this.plannedQuantity = plannedQuantity;
        this.outputQuantity = outputQuantity;
        this.reworkQuantity = this.reworkQuantity;
        this.noOfOperators = noOfOperators;
        this.productiveMinutes = productiveMinutes;
        this.efficiency = efficiency;
        this.idleMinutes = idleMinutes;
        this.idleWorkstations = idleWorkstations;
        this.reworkQuantity = reworkQuantity;
        this.totalStyles = totalStyles;
        this.totalWorkstations = totalWorkstations;
    }
}



